export default {
  projectType: 'chat',
  serverUrl: process.env.SERVER_URL,
  serverWebSocketUrl: process.env.SERVER_WEB_SOCKET_URL
}



// WEBPACK FOOTER //
// ./src/config/index.js